import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IViewablePhoto } from '../../../models/customer-orders/orders';

/**
 * DOVE-2362 / DOVE-2538 — the driver's scan photo slot for one order line. Four states:
 * photo / photo still downloading / no photo on a Unique line / not applicable on a Generic
 * line. None of them is a warning.
 */
@Component({
	selector: 'app-order-line-photo-thumb',
	templateUrl: './order-line-photo-thumb.component.html',
	styleUrl: './order-line-photo-thumb.component.scss'
})
export class OrderLinePhotoThumbComponent {
	@Input() photo: IViewablePhoto | null = null;
	@Input() photoUrl: string | null = null;
	@Input() isGeneric = false;

	@Output() view = new EventEmitter<void>();
}
